import { DropdownMenu } from '@octopus-do/octopus-storybook'
import {
  Code,
  CodeInline,
  FigmaLogo,
  Image,
  Pdf,
  Plug,
  Table,
  TableExcel,
  Text,
  TextWord,
  WordpressLogo,
} from '@octopus-do/octopus-storybook/icons'
import type React from 'react'
import { useSelector } from 'react-redux'

import { selectIsLoading } from '@/store'
import { AiPromptIcon } from './components'

// The file exports take a while: the item shows a loader in its icon slot
// and the menu stays open until the file is ready.
export const ExportContent: React.FC = () => {
  const pdfLoading = useSelector(selectIsLoading('export_pdf'))
  const txtLoading = useSelector(selectIsLoading('export_txt'))
  const xlsLoading = useSelector(selectIsLoading('export_xls'))
  const docLoading = useSelector(selectIsLoading('export_doc'))

  return (
    <>
      <DropdownMenu.Button icon={FigmaLogo} id="figma" title="Figma" />
      <DropdownMenu.Button
        icon={AiPromptIcon}
        id="ai_prompt"
        title="Ai prompt"
      />
      <DropdownMenu.Button
        icon={WordpressLogo}
        id="wordpress"
        title="WordPress"
      />
      <DropdownMenu.Button icon={Code} id="sitemap" title="Sitemap.xml" />
      <DropdownMenu.Button icon={CodeInline} id="xml" title="XML" />
      <DropdownMenu.Button
        icon={Pdf}
        id="pdf"
        loading={pdfLoading}
        preventClose
        title="PDF"
      />
      <DropdownMenu.Button icon={Image} id="png" title="PNG" />
      <DropdownMenu.Button icon={Table} id="csv" title="CSV" />
      <DropdownMenu.Button
        icon={TableExcel}
        id="xls"
        loading={xlsLoading}
        preventClose
        title="Excel"
      />
      <DropdownMenu.Button
        icon={Text}
        id="txt"
        loading={txtLoading}
        preventClose
        title="TXT"
      />
      <DropdownMenu.Button
        icon={TextWord}
        id="doc"
        loading={docLoading}
        preventClose
        title="Word"
      />

      <DropdownMenu.Divider />
      <DropdownMenu.A
        href="https://help.octopus.do/article/140-develop-your-own-plugin"
        icon={Plug}
        title="Develop your plugin"
      />
    </>
  )
}
